import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

interface UseIsWebviewProps {
  initialIsWebview?: boolean;
}

export function useIsWebview({ initialIsWebview = false }: UseIsWebviewProps = {}) {
  const searchParams = useSearchParams();
  const [isWebview, setIsWebview] = useState(initialIsWebview);

  useEffect(() => {
    if (!searchParams.has('type')) {
      return;
    }
    setIsWebview(searchParams.get('type') === 'app' && !!window.ReactNativeWebView);
  }, [searchParams]);

  return isWebview;
}
